import FileUploaderModal from './FileUploaderModal'

export default FileUploaderModal
